<template>
  <div class="event">
    <p>{{ $store.getters['getClientMeta'].name }}</p>
    <h3 class="line-title">Geçmiş Hareketlerim</h3>

    <form v-on:submit.prevent="send" class="top-filter">
      <div class="buttons">
        <button  type="button" @click="form.type = '1'" class="button" :class="form.type == '1' ? 'active' : ''">Kimlik</button>
        <button  type="button" @click="form.type = '2'" class="button" :class="form.type == '2' ? 'active' : ''">Pasaport</button>
        <button  type="button" @click="form.type = '3'" class="button" :class="form.type == '3' ? 'active' : ''">Fatura</button>
      </div>
      <label class="file-input"> 
        <slot v-if="_.isNull(form.file)">
          Dosyanızı Seçiniz
        </slot>
        <slot v-else>
          <div class="text-success">Dosyanız Seçildi </div>
        </slot>
        <input @change="file($event)" type="file" size="60" >
      </label> 
      <ButtonLoader class="primary" :loader="btnLoading" :text="'Yükle'" >
        <template name="icon">
          <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
        </template>
      </ButtonLoader>
    </form>
    <div class="user-content-inc table-panel">
      <Loader v-if="loading" :style="!isMobile ? 'margin-top: -35px;' : ''" />
      <div class="panel" v-if="!loading">
        <div class="title">
          <div class="col id">ID</div>
          <div class="col">Belge Türü</div>
          <div class="col">Durum</div>
          <div class="col">Tarih</div>
        </div>
        <div class="content">
            <div class="table-col">
                <div class="item" v-for="item in documents" :key="item.document_id">
                  <div class="col id">#{{ item.document_id }}</div>
                  <div class="col"><b>{{ $t(item.type_name) }}</b></div>
                  <div class="col">
                    <div class="">{{ $t(item.status_name) }}</div>
                  </div>
                  <div class="col">{{ $moment(item.created_at).format('MM/DD HH:MM:SS') }}</div>
                </div>
            </div>
        </div>
      </div>
      <div v-show="!loading && !_.isEmpty(documents)">
        <br>
        <paginate
          :page-count="filter.pageTotal"
          :page-range="6"
          :force-page="filter.page"
          :margin-pages="2"
          :click-handler="fetchData"
          :prev-text="'Geri'"
          :next-text="'İleri'"
          :container-class="'pagination'"
          :page-class="'page-item'">
        </paginate>
      </div>
    </div>
  </div>
</template>
<script>
  import Header from '../../components/Common/User/Header'
  export default{
    data(){
      return{
        form:{
          type: null,
          file: null,
          file_src: null,
        },
        filter:{
          pageTotal: 0,
          size: 10,
          page: 1,
        },
        mobileFilter: false,
        btnLoading: false,
        loading: false,
        documents:{},
      }
    },
    components:{
      Header
    },
    watch:{
      mobileFilter(val){
        if(val){
          document.querySelector("#app").classList.add('lock');
        }else{
          document.querySelector("#app").classList.remove('lock');
        }
      }
    },
    created(){
      this.fetchData();
    },
    methods:{
        file(event){
          const file = event.target.files[0];
          this.form.file = file;
          this.form.file_src = URL.createObjectURL(file);
        },
        send(evt){    
          this.btnLoading = true;
          let data = new FormData();
          data.append('file', this.form.file);
          data.append('type', this.form.type);
          
          evt.preventDefault()
          axios.post('/user/document', data)
          .then((response)=>{
              this.fetchData();
              this.form.type = null;
              this.form.file = null;
              this.form.file_src = null;
              this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
          })
          .catch(() => {})
          .finally(() => {
            this.btnLoading = false;
            this.mobileFilter = false;
          });
        },
        filter_open(){
          this.mobileFilter = true;
        },
        fetchData(page = 1, size = null, silent = false){
          this.filter.page = page;

          if (!_.isNull(size)) 
          {
              this.filter.size = size;
          }
          
          if(silent == false){
            this.loading = true;
          } 
          axios.get('/user/document', {params: this.filter })
          .then((response)=>{
            this.documents = response.data.data;
            this.filter.pageTotal  = response.data.meta.last_page;
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
        }
    }
  }
 </script>